import React from "react";
import { MetricSelect } from "./MetricSelect";

export const TeamOverviewHeader = ({ uploadInfo }) => {
  const METRIC_OPTIONS = [
    "AVG",
    "OBP",
    "SLG",
    "OPS",
    "ISO",
    "K%",
    "BB%",
    "OPS+",
    "FLD%",
    "RCS%",
  ];

  return (
    <div className="p-4 sm:p-5 md:p-6 lg:p-8">
      <h3 className="text-xs sm:text-sm md:text-base font-semibold text-jp-ink mb-3 sm:mb-4 text-left">
        YOUR TEAM OVERVIEW
      </h3>

      <div className="flex flex-col lg:flex-row lg:items-start gap-4 sm:gap-6 mb-4 sm:mb-6">
        {/* Left: bullets */}
        <div className="lg:w-1/2">
          <ul className="text-[11px] sm:text-xs md:text-sm text-jp-ink space-y-1.5 sm:space-y-2 text-left">
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>{uploadInfo.count} players uploaded</span>
            </li>
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>
                Avg Batting Avg:{" "}
                <span className="font-semibold">{uploadInfo.avg.toFixed(3)}</span>
              </span>
            </li>
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>
                Weaknesses position:{" "}
                <span className="font-semibold">{uploadInfo.weakness}</span>
              </span>
            </li>
            <li className="flex items-start">
              <span className="mr-2">•</span>
              <span>
                Strengths:{" "}
                <span className="font-semibold">{uploadInfo.strengths}</span>
              </span>
            </li>
          </ul>
        </div>

        {/* Right: AI recommendation */}
        <div className="lg:w-1/2 text-[11px] sm:text-xs md:text-sm text-jp-ink text-left">
          <div className="font-semibold mb-1.5 sm:mb-2">AI RECOMMENDATION:</div>
          <p className="leading-relaxed">
            Based on your stats, we recommend exploring 3 JUCO catchers who match
            your team style.
          </p>
        </div>
      </div>

      {/* Metric dropdown row */}
      <div className="flex flex-col sm:flex-row sm:flex-wrap gap-2 sm:gap-3">
        <MetricSelect
          label="Primary Team Metric"
          value="AVG"
          options={METRIC_OPTIONS}
        />
        <MetricSelect
          label="Secondary Team Metric"
          value="AVG"
          options={METRIC_OPTIONS}
        />
        <MetricSelect
          label="Differential Metric"
          value="AVG"
          options={METRIC_OPTIONS}
        />
      </div>
    </div>
  );
};
